<script setup>
import { watch, onMounted } from 'vue';
import { useZohoTour } from 'dashboard/composables/useZohoTour';

const props = defineProps({
  conversationId: {
    type: [Number, String],
    default: 0,
  },
});

const { shouldShowTour, startTour } = useZohoTour();

const tryStartTour = () => {
  if (!shouldShowTour.value) return;
  // Delay to allow the DOM to fully render (WhatsApp button is conditional)
  setTimeout(startTour, 800);
};

onMounted(tryStartTour);

watch(
  () => props.conversationId,
  newId => {
    if (newId) tryStartTour();
  }
);
</script>

<template>
  <span />
</template>
